import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from "@angular/core";

@Component({
  selector: "app-button",
  templateUrl: "./button.component.html",
  styleUrl: "./button.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  public readonly htmlType: InputSignal<HTMLButtonElement["type"]> =
    input<HTMLButtonElement["type"]>("button");
  public readonly ariaLabel: InputSignal<string | undefined> = input<string | undefined>();
  public readonly size: InputSignal<
    "x-small" | "small" | "medium" | "table-small" | "input-btn" | "large"
  > = input<"x-small" | "small" | "medium" | "table-small" | "input-btn" | "large">("small");
  public readonly type: InputSignal<"primary" | "secondary" | "tertiary-table" | "tertiary"> =
    input<"primary" | "secondary" | "tertiary-table" | "tertiary">("primary");
  public readonly disabled: InputSignal<boolean> = input<boolean>(false);
  public readonly loading: InputSignal<boolean> = input<boolean>(false);
  public readonly addVoucherButton: InputSignal<boolean> = input<boolean>(false);

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  public readonly onClick: OutputEmitterRef<void> = output<void>();
  // Declared but never emitted: bound by 3 consumers (NB57), wiring it would double-submit.
  public readonly submitEvent: OutputEmitterRef<void> = output<void>();

  public handleOnClick(): void {
    if (this.disabled() || this.loading()) return;

    this.onClick.emit();
  }

  public handleSubmit(): void {
    if (this.disabled() || this.loading()) return;

    this.submitEvent.emit();
  }
}
